<template>
<div>
  <div class="card">
    <div class="card-header">
      <p-button type="default" link style="float: left;" @click="navigateBack()" class="mt-0" title="Zurück"><i class="bi bi-arrow-left" style="font-size: 16px;"></i></p-button><h3 class="title mb-1"><b>{{ trainerName }}</b></h3>
    </div>
    <div class="card-body">
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Vor- und Nachname"
                      v-model="trainerName">
            </fg-input>
          </div>
          <div class="col-md-6">
          </div>
        </div>
          <h5 class="pt-4">Kontaktdaten</h5>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Telefon"
                      v-model="trainerTelefon">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="email"
                      label="E-Mail"
                      v-model="trainerMail">
            </fg-input>
          </div>
        </div>
        <h5 class="pt-4">Notfallkontakt</h5>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Name Notfallkontakt"
                      v-model="trainerNotfallkontaktName">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Telefon Notfallkontakt"
                      v-model="trainerNotfallkontaktNummer">
            </fg-input>
          </div>
        </div>
        <h5 class="pt-4">Vertragsdaten</h5>
        <div class="row">
          <div class="col-md-3">
            <label>Wochenstunden</label><br>
            <el-input-number v-model="trainerWochenstunden" :min="0" :max="60"></el-input-number>
          </div>
          <div class="col-md-3">
            <label>Urlaubstage</label><br>
            <el-input-number v-model="trainerUrlaubstage" :min="0" :max="50"></el-input-number>
          </div>
          <div class="col-md-6">
            <label>Letzter Erste-Hilfe-Kurs</label><br>
            <el-date-picker
              v-model="trainerErsteHilefeKursDatum"
              type="month"
              placeholder="Monat wählen"
              format="MM/yyyy"
              :picker-options="pickerOptions1">
            </el-date-picker>
          </div>
        </div>
        <div class="row pb-4">
          <div class="col-md-12">
        <h5 class="pt-4">Arbeitsbereiche</h5>
        <div class="row">
          <div class="col-md-3">
            <p-switch v-model="trainerIsEinweiser" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Betreuer
          </div>
          <div class="col-md-3">
              <p-switch v-model="trainerIsRetter" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Retter
          </div>

          <div class="col-md-3">
            <p-switch v-model="trainerIsKasse" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Kasse
          </div>
          <div class="col-md-3">
              <p-switch v-model="trainerIsHT" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Haupttrainer
          </div>
        </div>
          </div>
        </div>

        <div class="text-right pt-3">
          <button type="reset" class="btn btn-danger btn-fill btn-wd" @click.prevent="removeTrainer">
            <i class="bi bi-trash"></i> Löschen
          </button>
          <button type="reset" class="btn btn-warning btn-fill btn-wd" @click.prevent="onCancel">
            Abbrechen
          </button>
          <button type="submit" class="btn btn-success btn-fill btn-wd" @click.prevent="updateTrainer">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>

  <div class="card mt-3">
    <div class="card-header">
      <h5 class="title mb-0">Unterweisungen</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <h6>Offen</h6>
          <el-table :data="openInstructions" header-row-class-name="text-primary" empty-text="Keine offenen Unterweisungen.">
            <el-table-column prop="title" label="Titel" min-width="160"></el-table-column>
            <el-table-column prop="assignedAtLabel" label="Zuweisung" min-width="140"></el-table-column>
            <el-table-column prop="completedAtLabel" label="Erledigt am" min-width="140"></el-table-column>
          </el-table>
        </div>
        <div class="col-md-6">
          <h6>Erledigt</h6>
          <el-table :data="doneInstructions" header-row-class-name="text-primary" empty-text="Keine erledigten Unterweisungen.">
            <el-table-column prop="title" label="Titel" min-width="160"></el-table-column>
            <el-table-column prop="assignedAtLabel" label="Zuweisung" min-width="140"></el-table-column>
            <el-table-column prop="completedAtLabel" label="Erledigt am" min-width="140"></el-table-column>
            <el-table-column label="Unterschrift" min-width="120">
              <template #default="scope">
                <div v-if="scope.row.signature">
                  <img :src="scope.row.signature" alt="Unterschrift" @click="showSignatureDialogFunction(scope.row)" style="max-height: 60px; max-width: 100px; border: 1px solid #ccc;"/>
                </div>
                <div v-else>
                  -
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>

  <div class="alert alert-info" role="alert" v-if="paperShiftSyncEnabled == 1">
      <h4 class="alert-heading mt-0">Papershift</h4>
  Name, Kontaktdaten und der Notfallkontakt werden aus Papershift synchronisiert und können nur dort geändert werden.
</div>

 <!-- Signature dialog -->
    <el-dialog title="Unterschrift" :visible.sync="showSignatureDialog" :close-on-click-modal="true">
      <img :src="dialogSignature.signature" alt="Unterschrift" style="max-width: 100%; max-height: 80vh;"/>
      <span>{{ trainerName }} - ({{ dialogSignature.completedAtLabel }} Uhr)</span>
      <span slot="footer" class="dialog-footer">
        <p-button @click="showSignatureDialog = false">Schließen</p-button>
      </span>
    </el-dialog>
</div>
</template>
<script>
  import Vue from 'vue'
  import { db, fc } from '../../../../firebaseDb'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import router from '../../../../main'
  import store from "../../../../store";
  import { Input, Loading, InputNumber, MessageBox, Table, TableColumn, Dialog } from "element-ui";
  import { httpsCallable } from "firebase/functions";
import { remove } from 'nprogress';
import moment from "moment-timezone";

  export default {
    components: {
        PSwitch,
        [Input.name]: Input,
        [InputNumber.name]: InputNumber,
        MessageBox,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dialog.name]: Dialog,
    },

    data () {
      return {
          trainerDocID: 0,
          trainerName: "",
          trainerTelefon: "",
          trainerMail: "",
          trainerNotfallkontaktNummer: "",
          trainerNotfallkontaktName: "",
          trainerWochenstunden: 0,
          trainerUrlaubstage: 0,
          trainerErsteHilefeKursDatum: "",
          trainerIsRetter: false,
          trainerIsHT: false,
          trainerIsKasse: false,
          trainerIsEinweiser: false,
          trainerIsVA: false,
          trainerIsRetterBefore: false,
          trainerIsHTBefore: false,
          trainerIsKasseBefore: false,
          trainerIsVABefore: false,
          dialogSignature: {},
          showSignatureDialog: false,
          paperShiftSyncEnabled: process.env.VUE_APP_ENABLE_PAPERSHIFT_SYNC,
          pickerOptions1: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
            firstDayOfWeek: 1,
            shortcuts: [],
          },
          openInstructions: [],
          doneInstructions: [],
      }
    },
    created () {
        this.trainerDocID = this.$route.params.trainerId

        // get data of trainer
        const trainerRef = db.collection('trainer')
        trainerRef.doc(this.trainerDocID).get().then((doc) => {
            this.trainerName = doc.data().Name
            this.trainerTelefon = doc.data().Telefon
            this.trainerMail = doc.data().Mail
            this.trainerNotfallkontaktNummer = doc.data().NotfallkontaktNummer
            this.trainerNotfallkontaktName = doc.data().NotfallkontaktName
            this.trainerWochenstunden = doc.data().Wochenstunden
            this.trainerUrlaubstage = doc.data().Urlaubstage
            this.trainerErsteHilefeKursDatum = doc.data().ErsteHilfeKursDatum ? doc.data().ErsteHilfeKursDatum.toDate() : ""
            if (this.trainerErsteHilefeKursDatum && this.trainerErsteHilefeKursDatum.getFullYear() == 1970) {
              this.trainerErsteHilefeKursDatum = ""
            }
            if(doc.data().isRetter) {
              this.trainerIsRetter = doc.data().isRetter
              this.trainerIsRetterBefore = doc.data().isRetter
            }
            if(doc.data().isHT) {
              this.trainerIsHT = doc.data().isHT
              this.trainerIsHTBefore = doc.data().isHT
            }
            if(doc.data().isEinweiser) {
              this.trainerIsEinweiser = doc.data().isEinweiser
            }
            if(doc.data().isKasse) {
              this.trainerIsKasse = doc.data().isKasse
              this.trainerIsKasseBefore = doc.data().isKasse
            }
            if(doc.data().isVA) {
              this.trainerIsVA = doc.data().isVA
              this.trainerIsVABefore = doc.data().isVA
            }
        })

        // load assigned instructions for this trainer
        db
          .collection('trainer')
          .doc(this.trainerDocID)
          .collection('unterweisungen')
          .orderBy('assignedAt', 'desc')
          .onSnapshot((snap) => {
            const openList = [];
            const doneList = [];
            snap.forEach((doc) => {
              const d = doc.data();
              const title = d.title || '(ohne Titel)';
              const assignedAtLabel = this.formatDate(d.assignedAt);
              const completedAtLabel = d.ErledigtDatum ? this.formatDate(d.ErledigtDatum) : (d.completedAt ? this.formatDate(d.completedAt) : '-');
              const signature = d.signature || null;
              const row = { title, assignedAtLabel, completedAtLabel, signature };
              if ((d.status || 'offen') === 'erledigt') {
                doneList.push(row);
              } else {
                openList.push(row);
              }
            });
            this.openInstructions = openList;
            this.doneInstructions = doneList;
          });
    },
    methods: {
        onCancel () {
            router.push({ name: 'Trainer'})
        },
        formatDate(val) {
          if (!val) return '-';
          try {
            if (val.seconds) {
              return moment(new Date(val.seconds * 1000)).format('DD.MM.YY HH:mm');
            }
            return moment(new Date(val)).format('DD.MM.YY HH:mm');
          } catch(e) { return '-'; }
        },
        updateTrainer () {
            const newRoles = []
            if(this.trainerIsRetter == true && this.trainerIsRetterBefore == false) {
                newRoles.push('Retter')
            }
            if(this.trainerIsHT == true && this.trainerIsHTBefore == false) {
                newRoles.push('Haupttrainer')
            }
            if(this.trainerIsKasse == true && this.trainerIsKasseBefore == false) {
                newRoles.push('Kasse')
            }
            if(this.trainerIsVA == true && this.trainerIsVABefore == false) {
                newRoles.push('Veranstaltungen')
            }
            if(newRoles.length > 0) {
                // new role added. Send notification to PL and office
                var sendNotification = httpsCallable(fc, "trainer-NewRoleNotification");
                sendNotification({
                  TrainerName: this.trainerName,
                  NewRoles: newRoles.join(', '),
                  User: store.getters.user.data.displayName,
                  loc: store.getters.userlocation
                })
            }
            let ersteHilfe = null
            if(this.trainerErsteHilefeKursDatum) {
              ersteHilfe = this.trainerErsteHilefeKursDatum
            } else {
              ersteHilfe = new Date('1970-01-01')
            }
            const trainerRef = db.collection('trainer')
            trainerRef.doc(this.trainerDocID).update({ Name: this.trainerName, Telefon: this.trainerTelefon, Mail: this.trainerMail, NotfallkontaktName: this.trainerNotfallkontaktName, NotfallkontaktNummer: this.trainerNotfallkontaktNummer, Wochenstunden: this.trainerWochenstunden, Urlaubstage: this.trainerUrlaubstage, ErsteHilfeKursDatum: ersteHilfe, isEinweiser: this.trainerIsEinweiser, isRetter: this.trainerIsRetter, isKasse: this.trainerIsKasse, isHT: this.trainerIsHT, isVA: this.trainerIsVA }).then(() => {
                router.push({ name: 'Trainer'})
            }).catch((error) => {
                console.log('Fehler beim Speichern des Mitarbeiters: ' + error)
            })
        },
        removeTrainer() {
          MessageBox.confirm(
            "Soll der Mitarbeiter " + this.trainerName + " wirklich aus VertiHub gelöscht werden? Der Mitarbeiter wird für alle zugeordneten Standorte entfernt.",
            "Warnung",
            {
              confirmButtonText: "Löschen",
              cancelButtonText: "Abbrechen",
              type: "warning",
              callback: (action) => {
                if (action == "confirm") {
                  // remove trainer
                  db.collection("trainer")
                    .doc(this.trainerDocID)
                    .delete().then(() => {
                      router.push({ name: "Trainer" });
                    }).catch((error) => {
                      console.error("Fehler beim Löschen des Mitarbeiters: ", error);
                    });
                }
              },
            }
          );
        },
        navigateBack() {
          router.go(-1);
        },
        showSignatureDialogFunction(signature) {
          this.dialogSignature = signature;
          this.showSignatureDialog = true;
        },
    }
  }

</script>
<style>

</style>
